import isMobile from './helpers/mobile-check'

let menuIsOpen = false
const activeClass = 'is--active'

document.addEventListener('DOMContentLoaded', function () {
    registerMenuExpandEventListeners()
    registerMenuItemEventListeners()
    registerNewMenu()
})

function registerMenuExpandEventListeners() {
    const buttonElements = document.querySelectorAll('.js-menu-button') || []
    buttonElements.forEach((buttonElement) => {
        buttonElement.addEventListener('click', toggleMenu)
    })
}

function registerMenuItemEventListeners() {
    const menuItems = document.querySelectorAll('.js-menu-item') || []
    menuItems.forEach((menuItem) => {
        if (!isMobile()) {
            menuItem.addEventListener('mouseenter', () => {
                deactivateMenuItems(menuItems)
                activateMenuItem(menuItem)
            })
        }

        const toggleSubmenuButton = menuItem.querySelector('.js-toggle-submenu')
        if (toggleSubmenuButton) {
            toggleSubmenuButton.addEventListener('click', (clickEvent) => {
                clickEvent.preventDefault()
                const isActive = menuItem.classList.contains(activeClass)
                deactivateMenuItems(menuItems)
                if (!isActive) {
                    activateMenuItem(menuItem)
                }
            })
        }
    })
}

function toggleMenu(clickEvent) {
    clickEvent.preventDefault()
    const menuElement = document.querySelector('.js-menu')

    if (menuElement) {
        if (menuIsOpen) {
            menuElement.classList.remove(activeClass)
        } else {
            menuElement.classList.add(activeClass)
        }

        menuIsOpen = !menuIsOpen
    }
}

function activateMenuItem(menuItem) {
    menuItem.classList.add(activeClass)
}

function deactivateMenuItems(menuItems) {
    menuItems.forEach((menuItem) => {
        menuItem.classList.remove(activeClass)
    })
}

/* New menu */
function registerNewMenu() {
    document.addEventListener('click', event => {

        if (event.target.classList.contains('js-ddmenu')) {
            event.target.nextElementSibling.classList.toggle('collapsed');
        }
        else {
            Array.from(document.querySelectorAll('.collapsed')).forEach(
                (el) => el.classList.remove('collapsed')
            );
        }



    })
}


